import { Component, OnInit } from '@angular/core';
import { Team } from '../../../shared';
import { ApiService } from '../../../shared';

@Component({
  selector: 'app-my-team-page',
  templateUrl: './my-team-page.component.html',
})
export class MyTeamPageComponent implements OnInit {
  title: string = "team";
  subtitle: string = "elves";
  team: Team;

  constructor(private apiService: ApiService) { }

  ngOnInit() {
    this.getMyTeam();
  }

  public getMyTeam(): void {
    this.apiService.getMyTeam()
      .subscribe(team => {
        this.team = team;
        this.subtitle = team.name;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/team/pages/my-team-page/my-team-page.component.ts